// SPDX-FileCopyrightText: 2026 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import useAllContractApi from 'hooks/useAllContractsApi';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, FooterButton } from '@tls/treact-ui';
import ContractsTable from './ContractsTable';

// Customers see their own contracts (server filters contracts/all by customer) in a modal instead of the page.
export default function CustomerContractsDialog({ open, onClose }: Readonly<Props>) {
  const { t } = useTranslation();
  const { data, isLoading } = useAllContractApi();

  return (
    <Dialog enableClosing open={open} size='large' onClose={onClose} data-testid='settings-contracts-customer-dialog'>
      <Dialog.DialogHeader label={t('settings.contracts.title')} showCloseButton />
      <Dialog.DialogContent data-testid='settings-contracts-customer-content'>
        <ContractsTable data={data ?? []} isLoading={isLoading ?? false} hideContact hideMaterialNumber />
      </Dialog.DialogContent>
      <Dialog.Footer
        right={[
          <FooterButton
            key='close'
            label={t('close')}
            onClick={onClose}
            variant='secondary'
            data-testid='settings-contracts-customer-close-button'
          />,
        ]}
      />
    </Dialog>
  );
}

interface Props {
  open: boolean;
  onClose: () => void;
}
